import React from "react";
import { Modal } from "react-bootstrap";
import _ from "lodash";

import { moment } from "../common/common";
import { setTimeout } from "timers";
import { getOwnerCars, getCarsLocationSleep } from "../../model/car";

import { commonErr } from "../common/errors";
import { LoadingInline, LoadingPage } from "../common/loading";
import { MessagePage } from "../common/messagebox";

import Header from "../components/header";

import {
	IcRefresh,
	IcBatteryGreen,
	IcBatteryYellow,
	IcBatteryRed,
	IcGPSFocus,
	IcBCrLocation,
	IcLocation18,
} from "../common/svg";

const MIN_MAP_RADIUS = 2000;
const MapType = 1; //0: GoogleMaps, 1: HereMap, 2: Map4D

var CarPopup;
/** Defines the CarPopup class. */
function defineCarPopupClass() {
	/**
	 * A customized popup on the map.
	 * @param {!google.maps.LatLng} position
	 * @param {!Element} content
	 * @constructor
	 * @extends {google.maps.OverlayView}
	 */
	CarPopup = function (car, position, type, ts) {
		// this.id = car.id;
		// this.name = car.name;
		this.position = position;

		var contentBox = document.createElement("div");
		contentBox.classList.add("popup-bubble-anchor", "car-gps");
		const content = document.createElement("div");
		content.classList.add("popup-bubble-content", "popup-car-gps");
		const contentGPSBox = document.createElement("div");
		contentGPSBox.classList.add("gps-box");
		const contentBoxText = document.createElement("div");
		contentBoxText.classList.add("box-text");
		let html = "";
		if (car) {
			html += '<span class="license-plate">' + car.licensePlate + "</span>";
		}
		if (ts) {
			html += '<span class="time">' + moment(ts).format("LT L") + "</span>";
		}

		contentBoxText.innerHTML = html;
		contentBox.appendChild(content);
		content.appendChild(contentGPSBox);
		contentGPSBox.appendChild(contentBoxText);

		this.anchor = document.createElement("div");
		this.anchor.classList.add("popup-tip-anchor");
		this.anchor.appendChild(contentBox);
	};

	// NOTE: google.maps.OverlayView is only defined once the Maps API has
	// loaded. That is why CarPopup is defined inside initMap().
	CarPopup.prototype = Object.create(window.google.maps.OverlayView.prototype);

	/** Called when the popup is added to the map. */
	CarPopup.prototype.onAdd = function () {
		this.getPanes().floatPane.appendChild(this.anchor);
	};

	/** Called when the popup is removed from the map. */
	CarPopup.prototype.onRemove = function () {
		if (this.anchor.parentElement) {
			this.anchor.parentElement.removeChild(this.anchor);
		}
	};

	/** Called when the popup needs to draw itself. */
	CarPopup.prototype.draw = function () {
		var divPosition = this.getProjection().fromLatLngToDivPixel(this.position);
		// Hide the popup when it is far out of view.
		var display = Math.abs(divPosition.x) < 4000 && Math.abs(divPosition.y) < 4000 ? "block" : "none";

		if (display === "block") {
			this.anchor.style.left = divPosition.x - 52 + "px";
			this.anchor.style.top = divPosition.y - 0 + "px";
		}
		if (this.anchor.style.display !== display) {
			this.anchor.style.display = display;
		}
	};

	/** Stops clicks/drags from bubbling up to the map. */
	CarPopup.prototype.stopEventPropagation = function () {
		var anchor = this.anchor;
		anchor.style.cursor = "auto";

		["click", "dblclick", "contextmenu", "wheel", "mousedown", "touchstart", "pointerdown"].forEach(function (event) {
			anchor.addEventListener(
				event,
				function (e) {
					e.stopPropagation();
				},
				{
					passive: true,
				}
			);
		});
	};
	CarPopup.prototype.hideBoxTime = function () {
		var anchor = this.anchor;
	};
}

class CarMapLocation extends React.Component {
	pMarkers = [];
	pPopups = [];

	componentDidMount() {
		if (MapType === 0) {
			defineCarPopupClass();
			this.initMap(this.refs, this.props.cars, this.props.markers);
		} else if (MapType === 1) {
			this.initHereMap(this.props.cars, this.props.markers);
		}
	}

	componentWillUpdate = (props, state) => {
		const oCars = this.props.cars;
		let { cars, markers, isUpdateBounds, filterValue } = props;
		if (MapType === 0) {
			// UPDATE POSITION, ICON, CARPOPUP CURRENT
			for (let i = 0; i < cars.length; ++i) {
				const carId = cars[i].id;
				const marker = markers[carId];
				const pPopup = this.pPopups[carId];
				pPopup.setMap(null);
				if (this.pMarkers[carId].map === null) {
					this.pMarkers[carId].setMap(this.map);
				}
				this.pMarkers[carId].setPosition(new window.google.maps.LatLng(marker.lat, marker.lng));
				this.pMarkers[carId].setIcon(this.buildIcon(marker.lat, marker.lng, marker.preLat, marker.preLng));

				const newPPopup = new CarPopup(
					marker.car,
					new window.google.maps.LatLng(marker.lat, marker.lng),
					1,
					marker.tsHistory ? marker.tsHistory : marker.ts
				);
				newPPopup.setMap(this.map);
				this.pPopups[carId] = newPPopup;
				if (filterValue.car === "") {
					window.google.maps.event.addListener(this.pMarkers[carId], "click", () => {
						this.props.filterWhenClickIcon(carId);
						this.props.getCarsLocationSleep([marker.car], 1, true);
						this.props.getHistoryCar(carId, 10);
					});
				} else {
					window.google.maps.event.clearListeners(this.pMarkers[carId], "click");
				}
			}

			// FILTER CAR
			if (filterValue.car !== "") {
				//  Hide all another cars
				for (let i = 0; i < oCars.length; ++i) {
					const oCarId = oCars[i].id;
					if (oCarId !== filterValue.car) {
						const pMarker = this.pMarkers[oCarId];
						pMarker.setMap(null);
						const pPopup = this.pPopups[oCarId];
						pPopup.setMap(null);
					}
				}
			}

			if (isUpdateBounds) {
				this.fitBounds(this.map, cars, markers);
			}
		} else if (MapType === 1) {
			window.addEventListener("resize", () => this.mapHere.getViewPort().resize());

			for (let i = 0; i < cars.length; ++i) {
				const carId = cars[i].id;
				const marker = markers[carId];
				this.mapHere.addObject(this.pMarkers[carId]);
				this.pMarkers[carId].setGeometry({ lat: marker.lat, lng: marker.lng });

				this.mapHere.addObject(this.pPopups[carId]);
				this.pPopups[carId].setGeometry({ lat: marker.lat, lng: marker.lng });
				this.pPopups[carId].setIcon(this.infoCarHerePopup(marker));
			}
			if (filterValue.car !== "") {
				//  Hide all another cars
				for (let i = 0; i < oCars.length; ++i) {
					const oCarId = oCars[i].id;
					if (oCarId !== filterValue.car) {
						const pMarker = this.pMarkers[oCarId];
						this.mapHere.addObject(pMarker);
						this.mapHere.removeObject(pMarker);

						const pPopup = this.pPopups[oCarId];
						this.mapHere.addObject(pPopup);
						this.mapHere.removeObject(pPopup);
					}
				}
			}
			if (isUpdateBounds) {
				this.fitHereBounds(cars, markers);
			}
		}
	};

	buildIcon = (lat, lng, preLat, preLng) => {
		const pre = new window.google.maps.LatLng(preLat, preLng);
		const cur = new window.google.maps.LatLng(lat, lng);
		var rotation = -90;
		if (preLat && preLng) {
			rotation = window.google.maps.geometry.spherical.computeHeading(pre, cur) - 90;
		}
		var scale = 0.5;

		return {
			path: "M63.656,43.791c-0.695-4.486-1.998-7.645-3.874-9.387c-1.422-1.271-3.185-0.922-3.22-0.913 c-0.375,0.005-37.69,0.501-40.094,0.572C10.641,34.235,7.685,39.597,7.685,50c0,10.402,2.956,15.765,8.784,15.937   c2.403,0.07,39.719,0.565,40.054,0.565c0.026,0.006,0.275,0.056,0.651,0.056c0.659,0,1.704-0.152,2.61-0.966   c1.874-1.738,3.177-4.896,3.872-9.384c0.512-3.311,0.486-6.156,0.485-6.208C64.143,49.948,64.168,47.103,63.656,43.791z    M16.195,50.755c-0.729,0-1.321-0.338-1.321-0.755s0.592-0.756,1.321-0.756s1.322,0.339,1.322,0.756S16.925,50.755,16.195,50.755z M94.822,33.357l-0.387-0.482c-2.192-2.729-3.924-4.886-9.569-4.886H64.785c-0.266,0-1.062,0.01-1.502,0.016   c0.591-1.85,0.316-3.496-0.755-4.444c-0.933-0.825-2.263-0.925-3.558-0.265c-0.292,0.148-0.242,0.663,0.113,2.63   c0.135,0.743,0.314,1.736,0.291,2.063c-3.052,0-7.566,0.033-12.343,0.066c-11.478,0.082-25.762,0.184-30.114-0.066   c-5.299-0.305-8.856,0.534-10.885,2.563C4.381,32.205,1.61,36.926,1.61,50c0,13.072,2.771,17.795,4.423,19.447   c2.029,2.028,5.589,2.868,10.885,2.562c4.353-0.25,18.637-0.148,30.114-0.067c4.776,0.035,9.291,0.067,12.343,0.067   c0.023,0.326-0.156,1.321-0.291,2.064c-0.355,1.966-0.405,2.481-0.113,2.629c0.566,0.29,1.144,0.434,1.688,0.434   c0.697,0,1.347-0.235,1.869-0.697c1.071-0.949,1.346-2.595,0.755-4.445c0.44,0.007,1.236,0.016,1.502,0.016h20.081   c5.646,0,7.377-2.156,9.569-4.886l0.387-0.481c3.584-4.425,3.766-14.64,3.766-16.643S98.406,37.782,94.822,33.357z M89.902,30.071   c0,0,1.478,0.938,2.575,2.312s1.927,2.88,1.927,2.88c-1.225,0.997-3.063,0.884-4.465-0.841   C88.537,32.697,88.678,31.066,89.902,30.071z M96.228,41.042c0.042,0.272,0.427,3.491,0.439,3.662   c-0.019-0.205-12.272-2.258-17.295-2.876c0.011,0.078-0.429-2.706-0.847-4.127C78.525,37.701,90.791,39.231,96.228,41.042z    M75.119,66.329c-1.944,3.381-5.636,3.466-8.604,3.532l-0.225,0.005c-0.4,0.01-0.965,0.014-1.663,0.014   c-4.574,0-14.829-0.191-21.433-0.442c-7.387-0.281-24.802-0.791-28.287-0.714c-3.361,0.07-5.387,0.111-7.834-3.818   C4.681,61.06,3.897,52.513,3.897,50s0.783-11.06,3.177-14.906c2.447-3.93,4.477-3.887,7.834-3.817   c3.48,0.072,20.9-0.434,28.287-0.715c7.609-0.289,20.064-0.499,23.096-0.428l0.225,0.004c2.968,0.067,6.659,0.15,8.604,3.533   c2.12,3.692,3.387,9.797,3.387,16.329C78.506,56.531,77.239,62.636,75.119,66.329z M92.478,67.616   c-1.098,1.374-2.575,2.312-2.575,2.312c-1.225-0.996-1.365-2.625,0.037-4.351c1.401-1.727,3.24-1.838,4.465-0.843   C94.404,64.734,93.575,66.241,92.478,67.616z M96.228,58.956c-5.437,1.812-17.702,3.342-17.702,3.342   c0.418-1.42,0.857-4.205,0.847-4.127c5.022-0.619,17.276-2.67,17.295-2.875C96.654,55.466,96.27,58.686,96.228,58.956z",
			fillColor: "#000",
			fillOpacity: 1,
			strokeWeight: 0,
			scale: scale,
			anchor: new window.google.maps.Point(29, 50),
			rotation: rotation,
		};
	};

	fitBounds = (map, cars, markers) => {
		var bounds = new window.google.maps.LatLngBounds();

		for (var i = 0; i < cars.length; ++i) {
			const marker = markers[cars[i].id];
			bounds.extend(new window.google.maps.LatLng(marker.lat, marker.lng));
		}

		const ne = bounds.getNorthEast();
		const center = bounds.getCenter();
		const mapRadius = window.google.maps.geometry.spherical.computeDistanceBetween(ne, center);

		if (mapRadius < MIN_MAP_RADIUS && cars.length === 1) {
			const circle = new window.google.maps.Circle({
				center: center,
				radius: MIN_MAP_RADIUS,
			});
			map.fitBounds(circle.getBounds());
		} else {
			map.fitBounds(bounds);
		}
	};

	initMap = (refs, cars, markers) => {
		const map = (this.map = new window.google.maps.Map(refs.map, {
			mapTypeControl: false,
			scrollwheel: true,
			clickableIcons: false,
			streetViewControl: false,
			zoomControl: true,
			zoomControlOptions: {
				style: window.google.maps.ZoomControlStyle.SMALL,
			},
			mapTypeId: window.google.maps.MapTypeId.ROADMAP,
			fullscreenControl: false,
		}));

		for (var i = 0; i < cars.length; ++i) {
			const marker = markers[cars[i].id];

			var pMarker = new window.google.maps.Marker({
				position: new window.google.maps.LatLng(marker.lat, marker.lng),
				icon: this.buildIcon(marker.lat, marker.lng, marker.preLat, marker.preLng),
				map: map,
				zIndex: 99999,
			});

			const pPopup = new CarPopup(
				marker.car,
				new window.google.maps.LatLng(marker.lat, marker.lng),
				1,
				marker.ts,
				marker.speed
			);
			pPopup.setMap(map);

			this.pMarkers[marker.car.id] = pMarker;
			this.pPopups[marker.car.id] = pPopup;

			window.google.maps.event.addListener(pMarker, "click", () => {
				this.props.filterWhenClickIcon(marker.car.id);
				this.props.getCarsLocationSleep([marker.car], 1, true);
				this.props.getHistoryCar(marker.car.id, 10);
			});
		}

		this.fitBounds(map, cars, markers);
	};

	fitHereBounds = (cars, markers) => {
		var latMarker = [];
		var lngMarker = [];
		for (var i = 0; i < cars.length; ++i) {
			const marker = markers[cars[i].id];
			latMarker = [...latMarker, marker.lat];
			lngMarker = [...lngMarker, marker.lng];
		}
		var maxLat = Math.max(...latMarker);
		var minLat = Math.min(...latMarker);
		var maxLng = Math.max(...lngMarker);
		var minLng = Math.min(...lngMarker);

		var bbox = new window.H.geo.Rect(maxLat, minLng, minLat, maxLng);
		this.mapHere.getViewModel().setLookAtData({
			bounds: bbox,
			zoom: maxLat === minLat && maxLng === minLng ? 14 : null,
		});
	};

	buildHereIcon = (lat, lng) => {
		var svgCar = `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="46" viewBox="0 0 20 46" fill="none">
        <path d="M0.757812 12.6707L0.757812 6.9145L1.70995 4.99972C1.70995 4.99972 1.79882 2.78944 3.1699 1.83205C4.54098 0.862835 6.43256 0 9.99991 0C13.58 0 15.4588 0.862835 16.8299 1.83205C18.201 2.80126 18.2899 4.99972 18.2899 4.99972L19.242 6.9145V12.6707L18.8358 13.3208L18.8358 31.5585L19.242 33.3078V38.5321L18.5692 39.584C18.5692 39.584 18.5565 40.3996 18.2645 41.9953C17.4139 46.0376 9.98721 45.5766 9.98721 45.5766C9.98721 45.5766 2.56053 46.0258 1.70995 41.9953C1.41796 40.3996 1.40527 39.584 1.40527 39.584L0.732422 38.5321L0.732422 33.3078L1.13867 31.5585L1.13867 13.3208L0.757812 12.6707Z" fill="#4F4F4F"/>
        <path d="M9.99991 0L9.99991 45.5884C9.99991 45.5884 2.57322 46.0376 1.72265 42.0071C1.43066 40.4114 1.41796 39.5959 1.41796 39.5959L0.745117 38.5439L0.745117 33.3196L1.15136 31.5703L1.15136 13.3208L0.745117 12.6707L0.745117 6.9145L1.69726 4.99972C1.69726 4.99972 1.78612 2.78944 3.1572 1.83205C4.54098 0.862835 6.43256 0 9.99991 0Z" fill="#4F4F4F"/>
        <path d="M10 0.815552L13.999 1.44199L15.6621 12.9898L10 12.056V0.815552Z" fill="#6E6E6E"/>
        <path d="M9.99995 0.815552L6.00096 1.44199L4.33789 12.9898L9.99995 12.056V0.815552Z" fill="#828282"/>
        <path d="M17.8327 14.5028C17.8327 14.5028 15.2937 21.0391 15.865 27.0907C16.4363 33.1424 16.7156 35.0454 17.49 37.1729C17.6677 33.9816 18.1755 16.2285 17.8327 14.5028Z" fill="#BDBDBD"/>
        <path d="M10 40.6834C15.2304 40.6834 16.1572 39.4659 16.1572 39.4659L16.081 43.3073C16.081 43.3073 16.3857 44.5011 14.3037 44.903C12.2217 45.3049 10 45.2576 10 45.2576V40.6834V40.6834Z" fill="#6E6E6E"/>
        <path d="M16.0811 43.2952C16.0811 43.2952 17.541 42.9169 18.0361 41.5222L18.1758 42.3496C18.1758 42.3496 17.2871 44.0989 15.7383 44.2407C16.208 43.7916 16.0811 43.2952 16.0811 43.2952Z" fill="#EF4136"/>
        <path d="M13.6689 0.862622L14.0117 1.7491C14.0117 1.7491 12.6787 1.28813 10.0127 1.28813V0.401656C11.2695 0.389836 13.3515 0.744426 13.6689 0.862622Z" fill="#414042"/>
        <path d="M14.1641 1.22913L14.3672 1.82011C14.418 1.96194 14.5322 2.08014 14.6846 2.13924C15.3955 2.39927 17.5029 3.23847 17.8838 4.32588V3.53396C17.8838 3.54578 16.9824 2.02104 14.1641 1.22913Z" fill="#A7A9AC"/>
        <path d="M14.1641 1.2292L14.3672 1.82019C14.3926 1.87928 14.418 1.93838 14.4687 1.98566L15.5732 12.0678L15.3955 12.0087L13.999 1.74927L13.6562 0.862793L14.1641 1.2292Z" fill="#6E6E6E"/>
        <path d="M17.8847 24.0175C17.8847 24.3366 17.872 24.6557 17.872 24.9748L15.79 25.4831C15.79 25.2822 15.79 25.0812 15.79 24.8803L17.8847 24.0175Z" fill="#E0E0E0"/>
        <path d="M17.6308 33.7214L16.3613 31.8302C16.3486 31.6884 16.3232 31.5348 16.3105 31.3811L17.6435 33.3077C17.6308 33.4495 17.6308 33.5914 17.6308 33.7214Z" fill="#E0E0E0"/>
        <path d="M19.2549 6.91455V12.6707L18.8486 13.3208V31.5585L19.2549 33.3079L19.2549 38.5321L18.582 39.5841C18.582 39.5841 18.5693 40.3996 18.2773 41.9953C18.2519 42.1135 18.2139 42.2317 18.1885 42.3499L18.0488 41.5225C18.0488 41.5225 18.7851 30.6957 18.6328 25.4714C18.4678 20.259 18.6963 7.75375 17.8838 4.32605V3.53413L17.9854 3.43958C18.2773 4.25513 18.3027 4.99977 18.3027 4.99977L19.2549 6.91455Z" fill="#141414"/>
        <path d="M18.1123 15.6255L19.3057 16.0747C19.5088 16.1574 19.6992 16.2874 19.8262 16.4529L19.9658 16.6302C20.0674 16.772 19.9278 16.9612 19.75 16.9139L18.3789 16.5475C18.2393 16.512 18.1377 16.4056 18.0996 16.2756L18.0743 16.1692L17.9219 16.122C17.8584 16.0983 17.795 16.0629 17.7569 16.0038C17.6426 15.7792 17.8711 15.5428 18.1123 15.6255Z" fill="#141414"/>
        <path d="M2.17962 14.5028C2.17962 14.5028 4.71866 21.0391 4.14738 27.0907C3.57609 33.1424 3.2968 35.0454 2.52239 37.1729C2.34466 33.9816 1.83685 16.2285 2.17962 14.5028Z" fill="#BDBDBD"/>
        <path d="M9.99994 40.6834C4.76952 40.6834 3.84277 39.4659 3.84277 39.4659L3.91894 43.3073C3.91894 43.3073 3.61426 44.5011 5.69627 44.903C7.77828 45.3049 9.99994 45.2576 9.99994 45.2576V40.6834Z" fill="#828282"/>
        <path d="M3.91893 43.2952C3.91893 43.2952 2.45898 42.9169 1.96387 41.5222L1.82422 42.3496C1.82422 42.3496 2.71288 44.0989 4.2617 44.2407C3.79197 43.7916 3.91893 43.2952 3.91893 43.2952Z" fill="#EF4136"/>
        <path d="M6.34375 0.862622L6.00098 1.7491C6.00098 1.7491 7.33397 1.28813 9.99996 1.28813V0.401656C8.73044 0.389836 6.66113 0.744426 6.34375 0.862622Z" fill="#1C191A"/>
        <path d="M5.8486 1.22913L5.64547 1.82011C5.59469 1.96194 5.48044 2.08014 5.32809 2.13924C4.61716 2.39927 2.50976 3.23847 2.12891 4.32588V3.53396C2.12891 3.54578 3.03026 2.02104 5.8486 1.22913Z" fill="#A7A9AC"/>
        <path d="M5.84862 1.2292L5.6455 1.82019C5.62011 1.87928 5.59472 1.93838 5.54393 1.98566L4.43945 12.0678L4.61719 12.0087L6.01366 1.74927L6.35643 0.862793L5.84862 1.2292Z" fill="#4F4F4F"/>
        <path d="M2.12891 24.0176C2.12891 24.3367 2.1416 24.6558 2.1416 24.975L4.22361 25.4832C4.22361 25.2823 4.22361 25.0813 4.22361 24.8804L2.12891 24.0176Z" fill="#E0E0E0"/>
        <path d="M2.38281 33.7214L3.65233 31.8302C3.66503 31.6884 3.69042 31.5348 3.70311 31.3811L2.37012 33.3077C2.37012 33.4495 2.37012 33.5914 2.38281 33.7214Z" fill="#E0E0E0"/>
        <path d="M0.757813 6.91455L0.757813 12.6707L1.16406 13.3208L1.16406 31.5585L0.757813 33.3079L0.757813 38.5321L1.43066 39.5841C1.43066 39.5841 1.44335 40.3996 1.73534 41.9953C1.76073 42.1135 1.79882 42.2317 1.82421 42.3499L1.96386 41.5225C1.96386 41.5225 1.22753 30.6957 1.37988 25.4714C1.54491 20.259 1.3164 7.75375 2.12889 4.32605V3.53413L2.02733 3.43958C1.73534 4.25513 1.70995 4.99977 1.70995 4.99977L0.757813 6.91455Z" fill="#141414"/>
        <path d="M1.88777 15.6255L0.694426 16.0747C0.491303 16.1574 0.300875 16.2874 0.173923 16.4529L0.0342761 16.6302C-0.0672854 16.772 0.0723616 16.9612 0.250094 16.9139L1.62118 16.5475C1.76082 16.512 1.86238 16.4056 1.90047 16.2756L1.92586 16.1692L2.0782 16.122C2.14168 16.0983 2.20515 16.0629 2.24324 16.0038C2.37019 15.7792 2.12898 15.5428 1.88777 15.6255Z" fill="#141414"/>
        <path d="M15.4081 33.757L15.5351 33.7451C14.6718 22.9302 15.9921 18.5569 16.0048 18.5214L15.8778 18.486C15.8778 18.5332 14.5448 22.9183 15.4081 33.757Z" fill="#525878"/>
        <path d="M4.59179 33.757L4.46484 33.7451C5.32811 22.9302 4.00781 18.5569 3.99512 18.5214L4.12207 18.486C4.13476 18.5332 5.46776 22.9183 4.59179 33.757Z" fill="#434B6B"/>
        <path d="M15.789 19.4905C15.789 19.4905 13.7197 18.9823 10.0127 18.9823V11.2286C10.0127 11.2286 14.456 11.0986 16.8427 12.7061C17.4521 13.1316 17.5409 13.4743 17.4521 13.758C17.3632 14.0417 15.789 19.4905 15.789 19.4905Z" fill="#BDBDBD"/>
        <path d="M15.5097 33.2133L16.1699 39.454C16.1699 39.454 15.2431 40.6715 10.0127 40.6715L10.0127 33.6033C10 33.6033 13.7705 33.5678 15.5097 33.2133Z" fill="#BDBDBD"/>
        <path d="M4.22362 19.4905C4.22362 19.4905 6.29294 18.9823 9.99993 18.9823V11.2286C9.99993 11.2286 5.55661 11.0986 3.16992 12.7061C2.56055 13.1316 2.47168 13.4743 2.56055 13.758C2.64942 14.0417 4.22362 19.4905 4.22362 19.4905Z" fill="#BDBDBD"/>
        <path d="M4.50292 33.2133L3.84277 39.454C3.84277 39.454 4.76952 40.6715 9.99994 40.6715V33.6033C9.99994 33.6033 6.24216 33.5678 4.50292 33.2133Z" fill="#BDBDBD"/>
        <path d="M14.8486 19.3252C14.6201 19.2898 14.3662 19.2543 14.0615 19.2188L15.2803 11.9734C15.7627 12.1389 16.2197 12.3398 16.626 12.5998L14.8486 19.3252Z" fill="#E0E0E0"/>
        <path d="M13.1602 11.4532C13.6172 11.5242 14.0996 11.6187 14.5693 11.7487L13.6934 19.1715C13.4775 19.1478 13.249 19.1242 13.0078 19.1124L13.1602 11.4532Z" fill="#E0E0E0"/>
        <path d="M15.4082 39.9268C15.1162 40.0568 14.7226 40.1868 14.1894 40.305L13.8594 33.426C14.1641 33.4023 14.456 33.3669 14.7226 33.3314L15.4082 39.9268Z" fill="#E0E0E0"/>
        <path d="M4.60449 39.9268C4.89648 40.0568 5.29003 40.1868 5.82323 40.305L6.15331 33.426C5.84862 33.4023 5.55663 33.3669 5.29003 33.3314L4.60449 39.9268Z" fill="#E0E0E0"/>
        <path d="M11.8662 33.5559C12.2725 33.5441 12.7041 33.5204 13.1484 33.485L13.4277 40.4468C12.9834 40.5177 12.4629 40.5768 11.8662 40.6122V33.5559Z" fill="#E0E0E0"/>
        <path d="M15.9287 27.7878C15.9033 27.5633 15.8906 27.3269 15.8652 27.0787C15.8525 26.9368 15.8398 26.7832 15.8271 26.6413L17.8203 26.4877C17.8076 27.0314 17.7949 27.5751 17.7822 28.1188L15.9287 27.7878Z" fill="#E0E0E0"/>
        <path d="M17.9219 21.5591L15.9033 22.8001C15.9795 22.0082 16.0937 21.2518 16.2207 20.5189L17.9472 19.0297C17.9346 19.8098 17.9346 20.6608 17.9219 21.5591Z" fill="#E0E0E0"/>
        <path d="M14.6338 2.11586C14.748 2.03312 14.8877 1.98584 15.0527 1.98584C15.3828 1.98584 15.6621 2.19859 15.6621 2.45863C15.6621 2.49409 15.6621 2.51772 15.6494 2.55318C15.2559 2.37589 14.9004 2.23405 14.6846 2.15132C14.6719 2.1395 14.6592 2.12768 14.6338 2.11586Z" fill="white"/>
        <path d="M16.3984 2.73035C16.6143 2.73035 16.7793 2.84854 16.7793 3.0022C16.7793 3.04948 16.7666 3.08494 16.7412 3.13221C16.5508 3.01402 16.3603 2.89582 16.1572 2.78944C16.2334 2.75399 16.3096 2.73035 16.3984 2.73035Z" fill="white"/>
        <path d="M5.3662 2.11561C5.25194 2.03287 5.1123 1.9856 4.94726 1.9856C4.61719 1.9856 4.33789 2.19835 4.33789 2.45838C4.33789 2.49384 4.33789 2.51748 4.35059 2.55294C4.74414 2.37564 5.0996 2.23381 5.31542 2.15107C5.34081 2.13925 5.35351 2.12743 5.3662 2.11561Z" fill="white"/>
        <path d="M3.60156 2.73035C3.38574 2.73035 3.2207 2.84854 3.2207 3.0022C3.2207 3.04948 3.2334 3.08494 3.25879 3.13221C3.44922 3.01402 3.63964 2.89582 3.84277 2.78944C3.77929 2.75399 3.69043 2.73035 3.60156 2.73035Z" fill="white"/>
        <path d="M5.15037 19.3252C5.37889 19.2898 5.63279 19.2543 5.93748 19.2188L4.71874 11.9734C4.23632 12.1389 3.77929 12.3398 3.37305 12.5998L5.15037 19.3252Z" fill="#E0E0E0"/>
        </svg>`;

		var icon = new window.H.map.Icon(svgCar, { anchor: new window.H.math.Point(0, 20) });
		return new window.H.map.Marker({ lat: lat, lng: lng }, { icon: icon });
	};

	infoCarHerePopup = (marker) => {
		var contentGPSBox = document.createElement("div");
		contentGPSBox.classList.add("gps-box");
		contentGPSBox.style.margin = "35px 0 0 -37px";
		var contentBoxText = document.createElement("div");
		contentBoxText.classList.add("box-text");
		var html = "";
		if (marker.car) {
			html += '<span class="license-plate">' + marker.car.licensePlate + "</span>";
		}
		if (marker.ts) {
			html +=
				'<span class="time">' + moment(marker.tsHistory ? marker.tsHistory : marker.ts).format("LT L") + "</span>";
		}

		contentBoxText.innerHTML = html;
		contentGPSBox.appendChild(contentBoxText);

		var domIcon = new window.H.map.DomIcon(contentGPSBox);
		return domIcon;
	};

	carHerePopup = (marker) => {
		var licenseMarker = new window.H.map.DomMarker(
			{ lat: marker.lat, lng: marker.lng },
			{
				icon: this.infoCarHerePopup(marker),
			}
		);
		return licenseMarker;
	};

	initHereMap = (cars, markers) => {
		var platform = new window.H.service.Platform({
			useHTTPS: true,
			useCIT: true,
			apikey: "jlQhrU7SzPSOHM-CLMVJ_RgTN2K3ifYmhVPp4XRaBnc",
		});
		var defaultLayers = platform.createDefaultLayers();

		var map = (this.mapHere = new window.H.Map(this.refs.map, defaultLayers.vector.normal.map, {
			zoom: 5,
			center: { lat: 10.804993, lng: 106.644859 },
			padding: { top: 50, left: 75, bottom: 125, right: 75 },
		}));
		new window.H.mapevents.Behavior(new window.H.mapevents.MapEvents(map));
		window.addEventListener("resize", () => map.getViewPort().resize());

		for (var i = 0; i < cars.length; ++i) {
			const marker = markers[cars[i].id];
			var pMarker = this.buildHereIcon(marker.lat, marker.lng);
			map.addObject(pMarker);
			this.pMarkers[marker.car.id] = pMarker;

			var pPopup = this.carHerePopup(marker);
			map.addObject(pPopup);
			this.pPopups[marker.car.id] = pPopup;

			pMarker.addEventListener("tap", () => {
				this.props.filterWhenClickIcon(marker.car.id);
				this.props.getCarsLocationSleep([marker.car], 1, true);
				this.props.getHistoryCar(marker.car.id, 10);
			});
		}
		this.fitHereBounds(cars, markers);
	};

	render() {
		const { filterValue } = this.props;
		const isOneCar = filterValue.car !== "";

		return <div ref="map" className={`map-container ${isOneCar ? "tracking-car" : ""}`} />;
	}
}

class GPSFilter extends React.Component {
	constructor(props) {
		super(props);
	}

	resetFilter = () => {
		this.props.resetFilter();
		this.props.toggleFilter();
	};

	setFilter = (event) => {
		const { name, value } = event.target;
		this.props.setFilter({
			...this.props.filterValue,
			[name]: value,
		});
		this.props.toggleFilter();
	};

	render() {
		const { allCars, filterValue } = this.props;
		const isOneCar = filterValue.car !== "";
		return (
			<div className="modal-input-body">
				<div className="line-form">
					<div className="custom-input">
						<div className="wrap-info">
							<div className="title-status">
								<p className="font-14">Xe</p>
							</div>
						</div>
						<div className="custom-select">
							<select name="car" onChange={this.setFilter} value={filterValue.car}>
								<option key="" value="">
									Tất cả
								</option>
								{allCars &&
									allCars.map((car) => (
										<option key={car.id} value={car.id}>
											{car.name + " | " + car.licensePlate}
										</option>
									))}
							</select>
						</div>
					</div>
				</div>
				<div className="wrap-btn">
					<a className={`btn btn-reset btn-second ${isOneCar ? "has-dot-red" : ""}`} onClick={this.resetFilter}>
						Bỏ lọc
					</a>
				</div>
			</div>
		);
	}
}

class DetailsTripGPS extends React.Component {
	constructor() {
		super();
	}

	renderTime = (date) => {
		if (date === moment().format("L")) {
			return "Hôm nay";
		} else if (date === moment().subtract(1, "days").format("L")) {
			return "Hôm qua";
		} else {
			return date;
		}
	};

	render() {
		const {
			histories,
			more,
			cars,
			historiesRaw,
			showTitle,
			toggleDetailsTripGPS,
			isOpenDetailsTripGPS,
			refreshDetailsTrip,
		} = this.props;
		if (Object.keys(histories).length > 0) {
			const datesKey = Object.keys(histories);
			const datesValue = Object.values(histories);
			return (
				<div className={`left-table-container ${!showTitle ? "left-modal" : ""}`}>
					{showTitle && (
						<div className="left-table-close">
							<div
								className="close"
								onClick={() => {
									refreshDetailsTrip(cars);
								}}>
								<IcRefresh />
							</div>
						</div>
					)}
					{/*
            <InfiniteScroll
                pageStart={0}
                loadMore={() => {this.props.getHistoryCar(cars[0].id, historiesRaw.length)}}
                hasMore={more === 1}
                loader={<LoadingInlineSmall key={0} />}
                useWindow={false}
            >
*/}
					<div className="left-table-body">
						{showTitle && <h4 className="n-title">LỊCH SỬ</h4>}
						{datesKey &&
							datesKey.map((dk) => (
								<React.Fragment key={dk}>
									<h5>{this.renderTime(dk)}</h5>
									<div className="detail-tracking-item">
										{datesValue &&
											datesValue.map((dv, idx) => (
												<React.Fragment key={idx}>
													{dv
														.filter((dvc) => moment(dvc.ts).format("L") == dk)
														.map((dvc, idx) => (
															<div
																className="step"
																key={idx}
																onClick={() => {
																	this.props.setMarkerInHistory(dvc, cars);
																	{
																		isOpenDetailsTripGPS && toggleDetailsTripGPS();
																	}
																}}>
																{dvc.address !== "" ? (
																	<div className="time">
																		<p className="left">{moment(dvc.ts).format("LT")}</p>
																		<div className={`line-dot sleep`} />
																		<div className="right">
																			<div className="address" style={{ marginLeft: "0px" }}>
																				<IcLocation18 />
																				<p>{dvc.address}</p>
																			</div>
																		</div>
																	</div>
																) : (
																	<a
																		className="time"
																		target="_blank"
																		href={`https://www.google.com/maps/place/${dvc.lat},${dvc.lng}`}>
																		<p className="left">{moment(dvc.ts).format("LT")}</p>
																		<div className={`line-dot sleep`} />
																		<div className="right">
																			<div className="address" style={{ marginLeft: "0px" }}>
																				<IcLocation18 />
																				<p>{`Không lấy được địa chỉ, Toạ độ: ${dvc.lat},${dvc.lng}`}</p>
																			</div>
																		</div>
																	</a>
																)}
															</div>
														))}
												</React.Fragment>
											))}
									</div>
								</React.Fragment>
							))}
					</div>
					{/*                    
                </InfiniteScroll>
 */}
				</div>
			);
		} else {
			return (
				<div className="left-table-container">
					<div className="left-table-body">
						{showTitle && <h4 className="n-title">LỊCH SỬ</h4>}
						<LoadingInline />
					</div>
				</div>
			);
		}
	}
}

class DetailsTracking extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		const { cars, markers } = this.props;
		const carId = cars[0].id;
		const marker = markers[carId];
		const { batteryPercentage, ts, address, lastActiveTime, lat, lng } = marker;

		let batteryColor;
		let batteryClassName;
		if (batteryPercentage >= 50) {
			batteryColor = <IcBatteryGreen />;
			batteryClassName = "";
		} else if (batteryPercentage < 50 && batteryPercentage >= 15) {
			batteryColor = <IcBatteryYellow />;
			batteryClassName = "";
		} else {
			batteryColor = <IcBatteryRed />;
			batteryClassName = "text-danger";
		}

		return (
			<div className="detail-tracking" style={{ top: "10px" }}>
				<div className="parameter">
					<div className="parameter-item sleep">
						<p className="info">Mức pin</p>
						<div className="d-flex">
							{batteryColor}
							<p className={`desc ${batteryClassName}`}>{batteryPercentage}%</p>
						</div>
					</div>
				</div>
				<div className="line"> </div>
				<div className="move-car">
					<span className="status green-dot" />
					Tín hiệu gần nhất: {moment(lastActiveTime).format("LT L")}
				</div>
				{address !== "" ? (
					<div className="address">
						<div className="wrap-svg">
							<IcBCrLocation />
						</div>
						{`${address} lúc ${moment(ts).format("LT L")}`}
					</div>
				) : (
					<a className="address" href={`https://www.google.com/maps/place/${lat},${lng}`} target="_blank">
						<div className="wrap-svg">
							<IcBCrLocation />
						</div>
						{`Không lấy được địa chỉ, Toạ độ: ${lat},${lng} lúc ${moment(ts).format("LT L")}`}
					</a>
				)}
			</div>
		);
	}
}

export default class CarsGPSSleep extends React.Component {
	constructor() {
		super();
		this.state = {
			err: commonErr.INNIT,
			isUpdateBounds: true,
			isOpenFilter: false,
			filterValue: {
				car: "",
			},
			histories: [],
			historiesRaw: [],
			more: 0,
		};
	}

	componentDidMount() {
		getOwnerCars(0, 0, 0, 0, true).then((resp) => {
			if (resp.data.data && resp.data.data.cars) {
				const { cars } = resp.data.data;
				this.getCarsLocationSleep(cars, 1, true, true);
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});

		window.addEventListener("resize", this.updateDimensions);
		this.checkWidthWindow();
	}

	checkWidthWindow = () => {
		if (window.innerWidth <= 576) {
			this.setState({
				invalidWidth: true,
			});
		} else {
			this.setState({
				invalidWidth: false,
			});
		}
	};

	updateDimensions = () => {
		this.checkWidthWindow();
	};

	toggleBounds = () => {
		this.setState({
			isUpdateBounds: !this.state.isUpdateBounds,
		});
	};

	turnOnBounds = () => {
		this.setState({
			isUpdateBounds: true,
		});
	};

	turnOffBounds = () => {
		this.setState({
			isUpdateBounds: false,
		});
	};

	getCarsLocationSleep = (cars, count, isUpdateBounds, firstFlag) => {
		const carIds = cars.map((car) => car.id).join(";");
		getCarsLocationSleep(carIds, count).then(async (resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.carLocs && resp.data.data.carLocs.length > 0) {
				const markers = [];
				const validGPSCars = [];
				for (let carLoc of resp.data.data.carLocs) {
					const validGPSCar = cars.filter((car) => car.id === carLoc.carId)[0];
					validGPSCars.push(validGPSCar);
					const { lat, lon, ts, speed, addresses } = carLoc.loc || 0;
					const { batteryPercentage, lastActiveTime } = carLoc.status || 0;

					if (carLoc.loc.gps !== null) {
						const l = ts.length;
						markers[carLoc.carId] = {
							car: validGPSCar,
							ts: ts[l - 1] * 1000,
							lat: lat[l - 1],
							lng: lon[l - 1],
							speed: speed[l - 1],
							address: addresses[l - 1],
							batteryPercentage: batteryPercentage ? batteryPercentage : 0,
							lastActiveTime: lastActiveTime ? lastActiveTime : 0,
						};
					}
				}
				this.setState({
					err: commonErr.SUCCESS,
					isUpdateBounds,
					markers,
					cars: validGPSCars,
					allCars: firstFlag ? validGPSCars : this.state.allCars,
				});
				if (this.state.allCars.length === 1) {
					this.getHistoryCar(this.state.allCars[0].id, 10);
					this.setState({
						filterValue: {
							car: this.state.allCars[0].id,
						},
					});
				}
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});
	};

	getHistoryCar = (carId, count) => {
		getCarsLocationSleep(carId, count).then(async (resp) => {
			if (resp.data.error >= commonErr.SUCCESS && resp.data.data.carLocs && resp.data.data.carLocs.length > 0) {
				const historiesRaw = [];
				setTimeout(async () => {
					const { lat, lon, ts, speed, gps, addresses } = resp.data.data.carLocs[0].loc || 0;
					if (gps !== null) {
						for (let i = ts.length - 1; i >= 0; i--) {
							historiesRaw.push({
								ts: ts[i] * 1000,
								lat: lat[i],
								lng: lon[i],
								speed: speed[i],
								address: addresses[i],
							});
						}
					}
					this.setState({
						err: resp.data.error,
						historiesRaw: historiesRaw,
						histories: _.groupBy(historiesRaw, ({ ts }) => moment(ts).format("L")),
					});
				}, 500);
			} else {
				this.setState({
					err: commonErr.FAIL,
				});
			}
		});
	};

	// <- Filter
	toggleFilter = () => {
		this.setState({
			isOpenFilter: !this.state.isOpenFilter,
		});
	};

	setFilter = (filterValue) => {
		const { allCars } = this.state;
		this.setState({
			filterValue,
		});
		if (filterValue.car === "") {
			this.setState({
				histories: [],
				historiesRaw: [],
			});
			this.getCarsLocationSleep(allCars, 1, true);
		} else {
			// 1 car
			this.setState({
				histories: [],
				historiesRaw: [],
			});
			const cars = allCars.filter((car) => car.id === filterValue.car);
			this.getCarsLocationSleep(cars, 1, true);
			this.getHistoryCar(cars[0].id, 10);
		}
	};

	resetFilter = () => {
		const { allCars } = this.state;
		this.setState({
			histories: [],
			historiesRaw: [],
			filterValue: {
				car: "",
			},
		});
		this.getCarsLocationSleep(allCars, 1, true);
	};
	// -> Filter
	filterWhenClickIcon = (carId) => {
		this.setState({
			filterValue: {
				car: carId,
			},
		});
	};

	//Refresh Details Trip
	refreshDetailsTrip = (cars) => {
		this.setState({
			histories: [],
			historiesRaw: [],
		});
		this.getHistoryCar(cars[0].id, 10);
	};

	//GPS Setting

	toggleDetailsTracking = () => {
		this.setState({
			isOpenDetailsTracking: !this.state.isOpenDetailsTracking,
		});
	};

	toggleDetailsTripGPS = () => {
		this.setState({
			isOpenDetailsTripGPS: !this.state.isOpenDetailsTripGPS,
		});
	};

	setMarkerInHistory = (history, cars) => {
		const { markers } = this.state;
		markers[cars[0].id] = {
			...markers[cars[0].id],
			tsHistory: history.ts,
			lat: history.lat,
			lng: history.lng,
		};
		this.setState({
			markers,
		});
		this.turnOnBounds();
	};

	render() {
		const {
			err,
			cars,
			markers,
			isUpdateBounds,
			filterValue,
			dates,
			histories,
			historiesRaw,
			more,
			isOpenFilter,
			allCars,
			isOpenDetailsTracking,
			isOpenDetailsTripGPS,
		} = this.state;
		const isOneCar = filterValue.car !== "";
		var content;
		if (err === commonErr.INNIT) {
			content = <LoadingPage />;
		} else if (err <= commonErr.FAIL) {
			content = (
				<MessagePage
					message={
						<div>
							<div>Không tìm thấy dữ liệu hoặc bạn chưa có xe được tích hợp Mioto GPS</div>
							<div>
								(Tính năng mới trên Mioto, dành cho các chủ xe đã lắp đặt Mioto GPS. Liên hệ 19009271 để được tư vấn lắp
								đặt.)
							</div>
						</div>
					}
				/>
			);
		} else if (this.state.invalidWidth) {
			content = (
				<MessagePage
					message={
						<div>
							Tính năng chỉ hỗ trợ cho màn hình có kích thước lớn hơn 576px. Vui lòng xoay ngang màn hình hoặc sử dụng
							màn hình lớn hơn.
						</div>
					}
				/>
			);
		} else {
			var bodyContent = (
				<div className="tracking_cars--wrap position-relative">
					{markers && (
						<CarMapLocation
							historiesRaw={historiesRaw}
							turnOnBounds={this.turnOnBounds}
							turnOffBounds={this.turnOffBounds}
							cars={cars}
							markers={markers}
							isUpdateBounds={isUpdateBounds}
							filterValue={filterValue}
							filterWhenClickIcon={this.filterWhenClickIcon}
							getCarsLocationSleep={this.getCarsLocationSleep}
							getHistoryCar={this.getHistoryCar}
						/>
					)}
					<React.Fragment>
						{allCars.length !== 1 && (
							<button
								className={`btn btn--m btn-primary btn-filter ${isOneCar ? "has-dot-red" : ""}`}
								onClick={this.toggleFilter}>
								<span>Chọn xe</span>
							</button>
						)}
						{
							<div className={`icon-filter location ${isUpdateBounds && `active`}`} onClick={() => this.toggleBounds()}>
								<IcGPSFocus />
							</div>
						}
						{isOneCar && (
							<React.Fragment>
								<DetailsTracking cars={cars} markers={markers} historiesRaw={historiesRaw} />
								<DetailsTripGPS
									turnOnBounds={this.turnOnBounds}
									turnOffBounds={this.turnOffBounds}
									refreshDetailsTrip={this.refreshDetailsTrip}
									showTitle={true}
									histories={histories}
									more={more}
									getHistoryCar={this.getHistoryCar}
									filterValue={filterValue}
									cars={cars}
									historiesRaw={historiesRaw}
									setFilter={this.setFilter}
									dates={dates}
									setMarkerInHistory={this.setMarkerInHistory}
								/>
								<div className="tab-mode show-on-lg">
									<div className="tab-box">
										<a onClick={this.toggleDetailsTripGPS} className="view-mode">
											Lịch sử
										</a>
										<a onClick={this.toggleDetailsTracking} className="view-mode">
											Thông tin hiện tại
										</a>
									</div>
								</div>
							</React.Fragment>
						)}
					</React.Fragment>
				</div>
			);

			content = <div className="content">{bodyContent}</div>;
		}
		return (
			<div className="mioto-layout bg-gray">
				<Header />
				<section className="body">{content}</section>
				<Modal show={isOpenFilter} onHide={this.toggleFilter} dialogClassName="modal-s modal-input">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Chọn xe</h5>
					</Modal.Header>
					<Modal.Body>
						<GPSFilter
							toggleFilter={this.toggleFilter}
							dates={dates}
							allCars={allCars}
							filterValue={filterValue}
							setFilter={this.setFilter}
							resetFilter={this.resetFilter}
						/>
					</Modal.Body>
				</Modal>
				<Modal
					show={isOpenDetailsTracking}
					onHide={this.toggleDetailsTracking}
					dialogClassName="modal-s modal-detail-tracking">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>Thông tin hiện tại</h5>
					</Modal.Header>
					<Modal.Body>
						<DetailsTracking cars={cars} markers={markers} historiesRaw={historiesRaw} />
					</Modal.Body>
				</Modal>
				<Modal
					show={isOpenDetailsTripGPS}
					onHide={this.toggleDetailsTripGPS}
					dialogClassName="modal-s modal-detail-tracking-item">
					<Modal.Header closeButton={true} closeLabel={""}>
						<h5>lịch sử</h5>
					</Modal.Header>
					<Modal.Body>
						<DetailsTripGPS
							turnOnBounds={this.turnOnBounds}
							turnOffBounds={this.turnOffBounds}
							refreshDetailsTrip={this.refreshDetailsTrip}
							isOpenDetailsTripGPS={isOpenDetailsTripGPS}
							toggleDetailsTripGPS={this.toggleDetailsTripGPS}
							showTitle={false}
							histories={histories}
							more={more}
							getHistoryCar={this.getHistoryCar}
							filterValue={filterValue}
							cars={cars}
							historiesRaw={historiesRaw}
							setFilter={this.setFilter}
							dates={dates}
							setMarkerInHistory={this.setMarkerInHistory}
						/>
					</Modal.Body>
				</Modal>
			</div>
		);
	}
}
